/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { observer } from 'mobx-react';
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classname from 'classnames';

import { IHerbalFaqsData, IFaqItem } from './herbal-faqs.data';
import { IHerbalFaqsProps } from './herbal-faqs.props.autogenerated';

export interface IHerbalFaqsViewProps extends IHerbalFaqsProps<IHerbalFaqsData> {
    moduleProps: IModuleProps;
    containerProps: INodeProps;
    faqItems: IFaqItem[];
    expandedIndex: number | null;
    toggleFaq: (index: number) => void;
}

interface IHerbalFaqsState {
    expandedIndex: number | null;
}

/**
 * HerbalFaqs component
 * @extends {React.PureComponent<IHerbalFaqsProps<IHerbalFaqsData>>}
 */
@observer
class HerbalFaqs extends React.PureComponent<IHerbalFaqsProps<IHerbalFaqsData>, IHerbalFaqsState> {
    private readonly moduleName: string = 'herbal-faqs';

    public state: IHerbalFaqsState = {
        expandedIndex: null
    };

    private _toggleFaq = (index: number): void => {
        this.setState(prevState => ({
            expandedIndex: prevState.expandedIndex === index ? null : index
        }));
    };

    private _getFaqItems(): IFaqItem[] {
        const { config } = this.props;
        const faqItems: IFaqItem[] = [];
        if (config.faq1Question && config.faq1Question.trim() !== '') {
            faqItems.push({
                question: config.faq1Question,
                answer: config.faq1Answer || ''
            });
        }
        if (config.faq2Question && config.faq2Question.trim() !== '') {
            faqItems.push({
                question: config.faq2Question,
                answer: config.faq2Answer || ''
            });
        }
        if (config.faq3Question && config.faq3Question.trim() !== '') {
            faqItems.push({
                question: config.faq3Question,
                answer: config.faq3Answer || ''
            });
        }
        if (config.faq4Question && config.faq4Question.trim() !== '') {
            faqItems.push({
                question: config.faq4Question,
                answer: config.faq4Answer || ''
            });
        }
        if (config.faq5Question && config.faq5Question.trim() !== '') {
            faqItems.push({
                question: config.faq5Question,
                answer: config.faq5Answer || ''
            });
        }
        if (config.faq6Question && config.faq6Question.trim() !== '') {
            faqItems.push({
                question: config.faq6Question,
                answer: config.faq6Answer || ''
            });
        }
        if (config.faq7Question && config.faq7Question.trim() !== '') {
            faqItems.push({
                question: config.faq7Question,
                answer: config.faq7Answer || ''
            });
        }
        if (config.faq8Question && config.faq8Question.trim() !== '') {
            faqItems.push({
                question: config.faq8Question,
                answer: config.faq8Answer || ''
            });
        }
        if (config.faq9Question && config.faq9Question.trim() !== '') {
            faqItems.push({
                question: config.faq9Question,
                answer: config.faq9Answer || ''
            });
        }
        if (config.faq10Question && config.faq10Question.trim() !== '') {
            faqItems.push({
                question: config.faq10Question,
                answer: config.faq10Answer || ''
            });
        }
        if (config.faq11Question && config.faq11Question.trim() !== '') {
            faqItems.push({
                question: config.faq11Question,
                answer: config.faq11Answer || ''
            });
        }
        if (config.faq12Question && config.faq12Question.trim() !== '') {
            faqItems.push({
                question: config.faq12Question,
                answer: config.faq12Answer || ''
            });
        }
        if (config.faq13Question && config.faq13Question.trim() !== '') {
            faqItems.push({
                question: config.faq13Question,
                answer: config.faq13Answer || ''
            });
        }
        if (config.faq14Question && config.faq14Question.trim() !== '') {
            faqItems.push({
                question: config.faq14Question,
                answer: config.faq14Answer || ''
            });
        }
        if (config.faq15Question && config.faq15Question.trim() !== '') {
            faqItems.push({
                question: config.faq15Question,
                answer: config.faq15Answer || ''
            });
        }
        if (config.faq16Question && config.faq16Question.trim() !== '') {
            faqItems.push({
                question: config.faq16Question,
                answer: config.faq16Answer || ''
            });
        }
        if (config.faq17Question && config.faq17Question.trim() !== '') {
            faqItems.push({
                question: config.faq17Question,
                answer: config.faq17Answer || ''
            });
        }
        if (config.faq18Question && config.faq18Question.trim() !== '') {
            faqItems.push({
                question: config.faq18Question,
                answer: config.faq18Answer || ''
            });
        }
        if (config.faq19Question && config.faq19Question.trim() !== '') {
            faqItems.push({
                question: config.faq19Question,
                answer: config.faq19Answer || ''
            });
        }
        if (config.faq20Question && config.faq20Question.trim() !== '') {
            faqItems.push({
                question: config.faq20Question,
                answer: config.faq20Answer || ''
            });
        }
        return faqItems;
    }

    public render(): JSX.Element {
        const { config } = this.props;
        const { expandedIndex } = this.state;
        const faqItems = this._getFaqItems();

        const viewProps: IHerbalFaqsViewProps = {
            ...this.props,
            moduleProps: {
                moduleProps: this.props,
                className: classname(this.moduleName, config.className)
            },
            containerProps: {
                className: `${this.moduleName}__container`
            },
            faqItems,
            expandedIndex,
            toggleFaq: this._toggleFaq
        };

        return this.props.renderView(viewProps) as JSX.Element;
    }
}

export default HerbalFaqs;
